import { fetchDispatch } from 'data/helpers'

export const FETCH_CONVERSATIONS_LOADING = 'chatbotDashboard/FETCH_CONVERSATIONS_LOADING'
export const FETCH_CONVERSATIONS_SUCCESS = 'chatbotDashboard/FETCH_CONVERSATIONS_SUCCESS'
export const FETCH_CONVERSATIONS_FAILURE = 'chatbotDashboard/FETCH_CONVERSATIONS_FAILURE'

export const FETCH_REQUESTS_LOADING = 'chatbotDashboard/FETCH_REQUESTS_LOADING'
export const FETCH_REQUESTS_SUCCESS = 'chatbotDashboard/FETCH_REQUESTS_SUCCESS'
export const FETCH_REQUESTS_FAILURE = 'chatbotDashboard/FETCH_REQUESTS_FAILURE'

export const FETCH_REQUEST_DETAIL_LOADING = 'chatbotDashboard/FETCH_REQUEST_DETAIL_LOADING'
export const FETCH_REQUEST_DETAIL_SUCCESS = 'chatbotDashboard/FETCH_REQUEST_DETAIL_SUCCESS'
export const FETCH_REQUEST_DETAIL_FAILURE = 'chatbotDashboard/FETCH_REQUEST_DETAIL_FAILURE'

export const CLEAR_REQUESTS = 'chatbotDashboard/CLEAR_REQUESTS'
export const CLEAR_REQUEST_DETAIL = 'chatbotDashboard/CLEAR_REQUEST_DETAIL'

export const fetchConversationsLoading = () => ({ type: FETCH_CONVERSATIONS_LOADING })
export const fetchConversationsSuccess = payload => ({
  type: FETCH_CONVERSATIONS_SUCCESS,
  payload,
})
export const fetchConversationsFailure = payload => ({
  type: FETCH_CONVERSATIONS_FAILURE,
  payload,
})

export const fetchRequestsLoading = conversationId => ({
  type: FETCH_REQUESTS_LOADING,
  conversationId,
})
export const fetchRequestsSuccess = (conversationId, payload) => ({
  type: FETCH_REQUESTS_SUCCESS,
  conversationId,
  payload,
})
export const fetchRequestsFailure = (conversationId, payload) => ({
  type: FETCH_REQUESTS_FAILURE,
  conversationId,
  payload,
})

export const fetchRequestDetailLoading = requestId => ({
  type: FETCH_REQUEST_DETAIL_LOADING,
  requestId,
})
export const fetchRequestDetailSuccess = (requestId, payload) => ({
  type: FETCH_REQUEST_DETAIL_SUCCESS,
  requestId,
  payload,
})
export const fetchRequestDetailFailure = (requestId, payload) => ({
  type: FETCH_REQUEST_DETAIL_FAILURE,
  requestId,
  payload,
})

export const clearRequests = () => ({ type: CLEAR_REQUESTS })
export const clearRequestDetail = () => ({ type: CLEAR_REQUEST_DETAIL })

export const fetchConversations = ({ userId, userEmail }) => {
  return async dispatch => {
    dispatch(fetchConversationsLoading())
    try {
      const params = new URLSearchParams()
      if (userId) params.append('userId', userId)
      if (userEmail) params.append('userEmail', userEmail)
      const queryString = params.toString()
      const path = `/api/chatbot_dashboard/conversations${queryString ? `?${queryString}` : ''}`

      const response = await fetchDispatch({
        path,
        method: 'GET',
      })
      dispatch(fetchConversationsSuccess(response))
    } catch (error) {
      dispatch(fetchConversationsFailure(error))
    }
  }
}

export const fetchConversationRequests = conversationId => {
  return async dispatch => {
    dispatch(fetchRequestsLoading(conversationId))
    try {
      const response = await fetchDispatch({
        path: `/api/chatbot_dashboard/conversations/${conversationId}/requests`,
        method: 'GET',
      })
      dispatch(fetchRequestsSuccess(conversationId, response))
    } catch (error) {
      dispatch(fetchRequestsFailure(conversationId, error))
    }
  }
}

export const fetchRequestDetail = requestId => {
  return async dispatch => {
    dispatch(fetchRequestDetailLoading(requestId))
    try {
      const response = await fetchDispatch({
        path: `/api/chatbot_dashboard/requests/${requestId}`,
        method: 'GET',
      })
      dispatch(fetchRequestDetailSuccess(requestId, response))
    } catch (error) {
      dispatch(fetchRequestDetailFailure(requestId, error))
    }
  }
}

const initialState = {
  conversationsLoading: false,
  conversations: [],
  requestsByConversation: {},
  requestsLoading: {},
  requestDetails: {},
  requestDetailLoading: {},
}

export const chatbotDashboardReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_CONVERSATIONS_LOADING:
      return {
        ...state,
        conversationsLoading: true,
      }
    case FETCH_CONVERSATIONS_SUCCESS:
      return {
        ...state,
        conversationsLoading: false,
        conversations: action.payload,
      }
    case FETCH_CONVERSATIONS_FAILURE:
      return {
        ...state,
        conversationsLoading: false,
      }
    case FETCH_REQUESTS_LOADING:
      return {
        ...state,
        requestsLoading: {
          ...state.requestsLoading,
          [action.conversationId]: true,
        },
      }
    case FETCH_REQUESTS_SUCCESS:
      return {
        ...state,
        requestsLoading: {
          ...state.requestsLoading,
          [action.conversationId]: false,
        },
        requestsByConversation: {
          ...state.requestsByConversation,
          [action.conversationId]: action.payload,
        },
      }
    case FETCH_REQUESTS_FAILURE:
      return {
        ...state,
        requestsLoading: {
          ...state.requestsLoading,
          [action.conversationId]: false,
        },
      }
    case FETCH_REQUEST_DETAIL_LOADING:
      return {
        ...state,
        requestDetailLoading: {
          ...state.requestDetailLoading,
          [action.requestId]: true,
        },
      }
    case FETCH_REQUEST_DETAIL_SUCCESS:
      return {
        ...state,
        requestDetailLoading: {
          ...state.requestDetailLoading,
          [action.requestId]: false,
        },
        requestDetails: {
          ...state.requestDetails,
          [action.requestId]: action.payload,
        },
      }
    case FETCH_REQUEST_DETAIL_FAILURE:
      return {
        ...state,
        requestDetailLoading: {
          ...state.requestDetailLoading,
          [action.requestId]: false,
        },
      }
    case CLEAR_REQUESTS:
      return {
        ...state,
        requestsByConversation: {},
        requestsLoading: {},
      }
    case CLEAR_REQUEST_DETAIL:
      return {
        ...state,
        requestDetails: {},
        requestDetailLoading: {},
      }
    default:
      return state
  }
}
